import React from 'react';
import CardLight from 'components/CardLight';
import moment from 'moment';
import { Row, Col } from 'react-bootstrap';
import { formatDateLabel } from 'utils/date';
import { EventProps } from 'types/Event';
import NoDataText from 'components/NoDataText';

type RelevantEventsListCardProps = {
  data?: EventProps[]
  fullHeight?: boolean
  onEventClick?: ( data: EventProps ) => void;
};

function RelevantEventsListCard( { data, fullHeight, onEventClick }: RelevantEventsListCardProps ) {
  return (
    <CardLight
      title="Eventos relevantes"
      fullHeight={fullHeight}
      extraClass="fc-events-list"
      isLoading={!data}
    >
      {( !!data && !data.length ) && <NoDataText text="Pronto verá los eventos más relevantes relativos a su posición global" /> }
      {( !!data && data.length ) ? (
        data.map( ( item ) => (
          <Row
            className="border-bottom py-2 cursor-pointer"
            key={item.eventoId}
            onClick={() => {
              if ( onEventClick ) onEventClick( item );
            }}
          >
            <h6 className="text--black9 mb-1 text-ellipsis">
              {item.titulo}
            </h6>

            <Col>
              <p className="text--gray2 m-0">{ moment.utc( item.fechaInicio ).local().format( 'DD-MM-YYYY' )}</p>
            </Col>

            <Col className="d-flex align-items-center justify-content-end">
              <p className="text--gray27 text--xs m-0">{formatDateLabel( item.fechaInicio )}</p>
            </Col>
          </Row>
        ) )
      ) : null }
    </CardLight>
  );
}

export default RelevantEventsListCard;
